var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-inline-block" },
    [
      _setup.show
        ? _c(
            _setup.Button,
            {
              attrs: { "default-class": "btn-light btn-sm border text-nowrap" },
              nativeOn: {
                click: function ($event) {
                  return _setup.openLogsModal.apply(null, arguments)
                },
              },
            },
            [
              _c("i", { staticClass: "bi bi-journal-text me-1" }),
              _vm._v(" Open logs\n    "),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }